import axios from 'axios';

// Setup axios interceptors to handle authentication globally
const setupAxiosInterceptors = () => {
  // Response interceptor for global authentication error handling
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        const errorData = error.response.data;
        
        if (errorData?.error === 'TOKEN_EXPIRED') {
          console.log("Authentication token expired. Logging out user...");
          logout(true, "Your session has expired. Please login again.");
        } else if (errorData?.error === 'INVALID_TOKEN') {
          console.log("Invalid token. Logging out user...");
          logout(true, "Your session is invalid. Please login again.");
        } else {
          console.log("Authentication failed. Logging out user...");
          logout(false);
        }
      }
      return Promise.reject(error);
    }
  );
};

// Check if token exists and is valid
const isAuthenticated = () => {
  try {
    const token = JSON.parse(localStorage.getItem('idToken'));
    return !!token?.jwtToken;
  } catch (error) {
    return false;
  }
};

// Enhanced logout function with optional message
const logout = (showMessage = false, customMessage = "Your session has expired. Please login again.") => {
  console.log("Logging out user...");
  
  // Clear all authentication and app data from localStorage
  localStorage.removeItem("idToken");
  localStorage.removeItem("user");
  localStorage.removeItem("uploadedFileData");
  localStorage.removeItem("contactData");
  
  // Show user-friendly notification if requested
  if (showMessage && window.alert) {
    setTimeout(() => {
      window.alert(customMessage);
    }, 100);
  }
  
  // Redirect to splash page (which handles login)
  setTimeout(() => {
    window.location.href = "/splash";
  }, showMessage ? 200 : 0);
};

export { setupAxiosInterceptors, isAuthenticated, logout };
